import { PropsFilter } from "../api/props-filter";

export class ClientPendingAcceptancesFilter extends PropsFilter {
  requestTypes: RequestType[] = [];
}

export enum RequestType {
  Default = 0,
  TnAAbsences = 1,
  TnAExtraHours = 2,
  ExpenseReports = 3,
}
